import useResponsive from '@parsina/framework/clinical/src/hooks/useResponsive';
import MyPageWeb from './MyPage.web';
import MyPageMobile from './MyPage.mobile';

// «صفحهٔ من» — the platform switch, nothing else (DESIGN_CONCEPT §4.4).
const MyPageScreen = () => {
  const { isMobile } = useResponsive();
  return isMobile ? <MyPageMobile /> : <MyPageWeb />;
};

export default MyPageScreen;
